<div mat-dialog-content>
  <div class="chat-container">
    <div class="top">
      <button class="close-button" mat-icon-button [disableRipple]="true" mat-dialog-close (click)="close()">
        <mat-icon fontSet="fas" fontIcon="fa-times"></mat-icon>
      </button>
      <div class="chatbot-icon">
        <mat-icon fontSet="fas" fontIcon="fa-comments"></mat-icon>
      </div>
      <div class="chatbot-title">
        <span class="title">{{ 'label_finesse' | translate }}</span>
        <span class="subtitle">{{ 'label_online' | translate }}</span>
      </div>
    </div>
    <div #messagesContainer class="conversation">
      @if (messages) {
        @for (message of messages; track message; let index = $index) {
          <div class="message" [ngClass]="!message.isUser ? 'finesse' : 'user'">
            <div class="message-header">
              @if (!message.isUser) {
                <div class="finesse-user">&nbsp;</div>
              }
              <span>{{ message.responder }} </span>
            </div>
            @if (message.info) {
              <span class="message-info">{{ message.info | translate }}</span>
            }
            @if (message.response) {
              <span class="message-text" [innerHtml]="message.response"></span>
            }
            @if (message.message) {
              <span class="message-info">{{ message.message | translate }}</span>
            }
            @if (message.commonQuestions) {
              <div class="message-common-questions">
                @for (question of message.commonQuestions; track question) {
                  <div class="question" (click)="askCommonQuestion(question)">
                    {{ question.value }}
                  </div>
                }
              </div>
            }
            @if (message.help) {
              <div class="message-help">
                <span class="help">{{ message.help | translate }}</span>
                <button
                  class="help-button"
                  [ngClass]="message.feedbackSent && message.feedbackValue ? 'clicked' : 'disabled'"
                  mat-icon-button
                  [disableRipple]="true"
                  (click)="commit(message)"
                  [disabled]="message.feedbackSent"
                >
                  <mat-icon fontSet="fas" fontIcon="fa-thumbs-up" color="primary"></mat-icon>
                </button>
                <button
                  class="help-button"
                  [ngClass]="message.feedbackSent && !message.feedbackValue ? 'clicked' : 'disabled'"
                  mat-icon-button
                  [disableRipple]="true"
                  (click)="deny(message)"
                  [disabled]="message.feedbackSent"
                >
                  <mat-icon fontSet="fas" fontIcon="fa-thumbs-down"></mat-icon>
                </button>
              </div>
            }
          </div>
        }
      }

      @if (isLoading) {
        <mat-toolbar class="table-footer-toolbar">
          @if (isLoading) {
            <mat-toolbar-row class="spinner">
              <mat-spinner diameter="50"></mat-spinner>
            </mat-toolbar-row>
          }
        </mat-toolbar>
      }
    </div>
    <div class="typing">
      <input
        type="text"
        matInput
        [(ngModel)]="inputMessage"
        cdkTextareaAutosize
        placeholder="{{ 'chatbot_message_placeholder' | translate }}"
        (keydown.enter)="$event.stopPropagation(); sendMessage()"
      />
      <button
        class="send"
        mat-icon-button
        (click)="$event.stopPropagation(); sendMessage()"
        matSuffix
        [disabled]="inputMessage == null || inputMessage == ''"
      >
        <mat-icon fontSet="far" fontIcon="fa-paper-plane"></mat-icon>
      </button>
    </div>
  </div>
</div>
